import { RankingBadgeParams, RankingBadgeProps, RankingBadgeStatusText, RankingStatusBadgeEnum } from './types';

export const getRankingBadgeProps = ({
	rankingStatus,
	badgeRank,
	showBadge,
	badgeCenter,
	bgColorClass,
	borderColorClass,
	textColorClass,
	size,
	year
}: RankingBadgeParams) => {
	const isTourPro = rankingStatus === RankingStatusBadgeEnum.TOUR_PRO;
	const isDefault = rankingStatus === RankingStatusBadgeEnum.DEFAULT;

	const finalBadgeRank = badgeRank && badgeRank !== 0 ? badgeRank.toString() : RankingStatusBadgeEnum.DEFAULT;
	const badgeStatus = rankingStatus ? RankingBadgeStatusText[rankingStatus] : RankingStatusBadgeEnum.DEFAULT;

	const statusTextFinal = isTourPro ? finalBadgeRank : badgeStatus;
	const defaultTextColor = isTourPro ? 'text-[#002B46]' : 'text-gray-700';

	const isFinalTextDefault = statusTextFinal === RankingStatusBadgeEnum.DEFAULT;

	const badgeProps: RankingBadgeProps = {
		statusText: statusTextFinal,
		isProPlayer: isTourPro,
		showBadge: showBadge && !isDefault && !isFinalTextDefault,
		badgeCenterClass: badgeCenter ? 'justify-center' : 'justify-start',
		borderColorClass: borderColorClass || 'border-gray-200',
		bgColorClass: bgColorClass || 'bg-gray-200',
		textColorClass: textColorClass || defaultTextColor,
		size: size || 'base',
		year: year
	};
	return badgeProps;
};
